import React from 'react';
import { useAuth } from '../../context/AuthContext';

// Заметная плашка над контентом для b2b_lead (демо-режим).
// Показывается только если b2bStatus === 'lead'.
// Цель: предупредить пользователя, что данные синтетические, а
// внешние сервисы (Майнкрафтия, Роботехника) не активируются.

const DemoBanner = () => {
  const { b2bStatus } = useAuth();
  if (b2bStatus !== 'lead') return null;

  return (
    <div style={{
      background: 'linear-gradient(90deg, #f59e0b 0%, #ef4444 100%)',
      color: '#fff',
      padding: '10px 24px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 14,
      flexWrap: 'wrap',
      fontSize: 14,
      fontWeight: 600,
      letterSpacing: '0.01em',
      boxShadow: '0 2px 6px rgba(0,0,0,0.15)',
      position: 'relative',
      zIndex: 10,
    }}>
      <span style={{
        background: 'rgba(255,255,255,0.2)',
        border: '1px solid rgba(255,255,255,0.4)',
        padding: '3px 10px',
        borderRadius: 999,
        fontSize: 11.5,
        textTransform: 'uppercase',
        letterSpacing: '0.08em',
        fontWeight: 800,
      }}>Демо-режим</span>

      <span>
        Это демонстрационный режим. Все ученики, оплаты и журнал —
        тестовые. Реальные аккаунты Майнкрафтии и Роботехники
        не активируются.
      </span>

      <a
        href="https://startklass.ru/cabinet"
        target="_blank"
        rel="noopener noreferrer"
        style={{
          background: '#fff',
          color: '#b45309',
          padding: '6px 14px',
          borderRadius: 8,
          fontWeight: 700,
          textDecoration: 'none',
          fontSize: 13.5,
          whiteSpace: 'nowrap',
        }}
      >
        Оплатить тариф →
      </a>
    </div>
  );
};

export default DemoBanner;
